"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsDateTimePicker = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrapDatetimepicker = _interopRequireDefault(require("@1stquad/react-bootstrap-datetimepicker"));
var _reactBootstrap = require("react-bootstrap");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
    DmsDateTimePicker Component

    This component renders a DateTime picker input using the `@1stquad/react-bootstrap-datetimepicker` library.
    It allows users to select a date and time, with support for various configurations such as
    disabled days of the week, custom display formats, and min/max date constraints. The component
    utilizes the `moment` library for date and time manipulation and formatting.

    Parameters:
    - dateTime (string|Date): The initial date and time value. If a string, it should match the `inputFormat`.
    - daysOfWeekDisabled (array): An array of days of the week to disable (0 for Sunday, 1 for Monday, etc.).
    - defaultText (string): The placeholder text to display when no date is selected.
    - inputDisplayFormat (string): The format in which the selected date and time are displayed in the input field.
    - inputFormat (string): The format in which the date and time are expected in the `dateTime` prop.
    - format (string): The format in which the date and time should be returned by the `onChange`, `onBlur`, and `onEnterKeyDown` handlers.
    - inputProps (object): Additional props to pass to the input element.
    - inputRef (function|RefObject): A ref to attach to the input element.
    - maxDate (string|Date): The maximum selectable date. If a string, it should match the `inputFormat`.
    - minDate (string|Date): The minimum selectable date. If a string, it should match the `inputFormat`.
    - mode (string): The mode of the DateTime picker ('date', 'time', or 'datetime').
    - name (string): The name attribute for the input element.
    - onBlur (function): A function to call when the input loses focus.
    - onChange (function): A function to call when the date or time is changed.
    - onEnterKeyDown (function): A function to call when the Enter key is pressed.
    - size (string): The size of the input element ('sm', 'md', 'lg').
    - showToday (bool): Whether to show the "Today" button in the DateTime picker.
    - startOfWeek (string): The start of the week ('isoWeek' or 'week').
    - tabIndex (number): The tab index of the input element.
    - viewMode (string): The initial view mode of the DateTime picker ('days', 'months', 'years', 'decades').

    The component uses the `moment` library to handle date and time formatting and parsing. The `dateTime` prop is
    converted to a Unix timestamp (milliseconds since the Unix Epoch) for internal use, and the selected date and time
    are formatted according to the `format` prop before being passed to the `onChange`, `onBlur`, and `onEnterKeyDown` handlers.

 * More info: https://www.npmjs.com/package/@1stquad/react-bootstrap-datetimepicker
 *            https://github.com/1stQuad/react-bootstrap-datetimepicker
 * 
 */

const DmsDateTimePicker = props => {
  let {
    dateTime,
    daysOfWeekDisabled,
    defaultText,
    inputDisplayFormat,
    inputFormat,
    format,
    inputProps,
    inputRef,
    maxDate,
    minDate,
    mode,
    name,
    onBlur,
    onChange,
    onEnterKeyDown,
    size,
    showToday,
    startOfWeek,
    tabIndex,
    viewMode
  } = props;
  dateTime = dateTime || null;
  daysOfWeekDisabled = daysOfWeekDisabled || [];
  defaultText = defaultText || undefined;
  inputDisplayFormat = inputDisplayFormat || 'DD/MM/YYYY HH:mm';
  inputFormat = inputFormat || "YYYY-MM-DD HH:mm:SS";
  format = format || "YYYY-MM-DD HH:mm:SS";
  inputProps = inputProps || undefined;
  inputRef = inputRef || undefined;
  maxDate = maxDate || undefined;
  minDate = minDate || undefined;
  name = name || undefined;
  mode = mode || 'datetime';
  size = size || 'md';
  showToday = showToday || true;
  startOfWeek = startOfWeek || 'isoWeek';
  tabIndex = tabIndex || undefined;
  viewMode = viewMode || 'days';
  onBlur = typeof onBlur !== "undefined" ? onBlur : val => {};
  onChange = typeof onChange !== "undefined" ? onChange : val => {};
  onEnterKeyDown = typeof onEnterKeyDown !== "undefined" ? onEnterKeyDown : val => {};
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBootstrapDatetimepicker.default, {
    name: name,
    mode: mode,
    dateTime: dateTime && typeof dateTime === 'string' ? (0, _moment.default)(dateTime, inputFormat).format('x') : dateTime,
    format: format,
    inputDisplayFormat: inputDisplayFormat,
    inputFormat: inputFormat,
    onChange: value => onChange(_moment.default.utc(value, inputFormat).format(format)),
    onBlur: value => onBlur(_moment.default.utc(value, 'x').format(format)),
    onEnterKeyDown: value => onEnterKeyDown(_moment.default.utc(value, 'x').format(format)),
    showToday: showToday,
    size: size,
    daysOfWeekDisabled: daysOfWeekDisabled,
    inputProps: inputProps,
    inputRef: inputRef,
    minDate: minDate && typeof minDate === 'string' ? _moment.default.utc(minDate, inputFormat) : minDate,
    maxDate: maxDate && typeof maxDate === 'string' ? _moment.default.utc(maxDate, inputFormat) : maxDate,
    viewMode: viewMode,
    defaultText: defaultText,
    tabIndex: tabIndex,
    startOfWeek: startOfWeek
  }));
};
exports.DmsDateTimePicker = DmsDateTimePicker;